import React from "react";
import { WarningIcon } from "../common/icons/WarningIcon";
import { PrimaryButton } from "../disease_knowledge/components/PrimaryButton";
import classes from "./ErrorVerification.module.scss";

export function ErrorVerification() {

    const onClick = () => {
        window.close();
    };

    return (
        <div className={classes.container}>
            <div className={classes.message}>
                <WarningIcon size={"40px"}/>
                エラーが発生しました。時間をおいて再度実行をお願いします
            </div>
            <PrimaryButton onClick={onClick}>閉じる</PrimaryButton>
        </div>
    );
}

